import React from 'react';
import { Dialog, Typography as TypographyOld, Button } from '@material-ui/core';
import { ConfirmationModal, RichTextViewer } from 'seagull';
import styles from "./SimpleTextModal.module.scss";
const autoprefix = 'simple-text-modal-';
export default function SimpleTextModal(_ref) {
  let {
    title,
    text,
    onClose: _onClose,
    show = false,
    newDesign = false
  } = _ref;
  return newDesign ? /*#__PURE__*/React.createElement(ConfirmationModal, {
    "data-testid": autoprefix + 'title',
    title: title,
    textAlignCenter: false,
    onPrimaryButtonClick: _onClose,
    onCloseButtonClick: _onClose,
    primaryButtonLabel: "OK",
    content: /*#__PURE__*/React.createElement(RichTextViewer, {
      value: text,
      "data-testid": autoprefix + 'text'
    })
  }) : /*#__PURE__*/React.createElement(Dialog, {
    className: styles.main,
    open: show,
    onClose: (event, reason) => {
      if (reason === 'backdropClick') {
        return;
      }
      _onClose();
    },
    scroll: "paper",
    maxWidth: "xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.dialogHeader
  }, /*#__PURE__*/React.createElement(TypographyOld, {
    className: styles.modalTitle,
    "data-testid": autoprefix + 'title'
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: styles.dialogContent
  }, /*#__PURE__*/React.createElement(RichTextViewer, {
    value: text,
    "data-testid": autoprefix + 'text'
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.dialogFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    className: styles.dialogFooterButton,
    onClick: _onClose
  }, /*#__PURE__*/React.createElement(TypographyOld, {
    className: styles.dialogFooterButtonText
  }, "Ok"))));
}